<template>
  <div class="container">
    <Navbar />
    <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link tag="li" :to="{ name: 'Home' }">
            <a>Home</a>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link tag="li" :to="{
            name: 'MyRestaurants',
          }">
            <a>{{ capitalizeFisrtLetterOfEachWord(userName) }}</a>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link tag="li" :to="{
            name: 'AccessUsersToOnlineOrders',
            params: { restId: restId, id: restNum },
          }">
            <a>Access Users</a>
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Remove user</li>
      </ol>
    </nav>
    <div class="add-new-restaurant-page">
      <!-- Add new restaurant -->
      <p>{{ userAddress }}</p>
      <form method="post" action="#" enctype="multipart/form-data">
        <div class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <h3>Remove Current User</h3>
          </div>
        </div>
        <div class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <div class="form-floating">
              <input type="text" class="form-control w300" id="userNameInput" placeholder="Employee/Manager Name"
                disabled v-model="userNameIs" />
              <label for="userNameInput">
                <faIcons :icon="['fas', 'user']" /> Employee/Manager
                Name
              </label>
              <span class="error-feedback" v-if="userPhoneErr">
                {{ userPhoneMsg }}
              </span>
            </div>
          </div>
        </div>
        <div class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <div class="form-floating" :class="{ 'form-data-error': userPhoneErr }">
              <input type="number" min="0" disabled id="userPhoneInput" placeholder="Employee/Manager Code"
                @keyup="validateRestaurantPhone($event)" @change="validateRestaurantPhone($event)"
                class="form-control w300" @keydown="
                  if (
  $event.key === '.' ||
  $event.key === '+' ||
  $event.key === 'e' ||
  $event.key === '-'
) {
  $event.preventDefault();
}
                " v-model.trim="userAccessCode" />
              <label for="userPhoneInput">
                <faIcons :icon="['fas', 'digital-tachograph']" />
                Employee/Manager Code
              </label>
              <small id="emailHelp" class="form-text text-muted w300">Remove from accessing my business.</small>
              <span class="error-feedback" v-if="userPhoneErr">
                {{ userPhoneMsg }}
              </span>
            </div>
          </div>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <button class="btn btn-outline-danger" @click.prevent="RemoveUserFromMyRestaurant()" v-if="signUpBtn">
            <faIcons :icon="['fas', 'user']" /> Remove User
          </button>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <div class="alert alert-success" role="alert" v-if="resultSuccess">
            {{ resultSuccessMsg }}
          </div>
          <div class="alert alert-danger" role="alert" v-if="resultErr">
            {{ resultErrMsg }}
          </div>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <router-link class="btn btn-outline-primary" :to="{
            name: 'AccessUsersToOnlineOrders',
            params: { restId: restId, id: restNum },
          }">
            <faIcons :icon="['fas', 'undo']" /> Don't remove
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapGetters } from "vuex";
import Navbar from "@/components/Header/Navbar.vue";
export default {
  name: "RemoveUserFromMyRestaurant",
  components: {
    Navbar,
  },
  data() {
    return {
      userNameIs: "",
      user: {
        uId: "",
        userId: "",
        uName: "",
        uEmail: "",
        uPassword: "",
        uMemberSince: "",
        uAddress: "",
        uPhone: "",
        uRole: "",
        uRoleIs: "",
      },
      restId: this.$route.params.restId,
      restNum: this.$route.params.id,
      userAccessCode: this.$route.params.userAccessId,
      currentRestaurantsArr: [],
      //address
      userAddress: "",
      userAddressErr: false,
      userAddressMsg: "",
      isuserAddressValidated: false,
      //phone
      userPhone: "",
      userPhoneErr: false,
      userPhoneMsg: "",
      isuserPhoneValidated: false,
      //name
      userName: "",
      userNameErr: false,
      userNameMsg: "",
      isuserNameValidated: false,

      resultSuccess: false,
      resultSuccessMsg: "",
      resultErr: false,
      resultErrMsg: "",
      image: "",
      is_DB_Connected: "",
      db_connection_msg: "",
      // apiMainUrl: "http://localhost/php/login-system-php-vue-2021/myData.php",
      apiMainUrl: this.$store.getters.MainUrl, //call global variable
      signUpBtn: true,
    };
  },
  mounted() {
    let user = localStorage.getItem("current-user-data");
    if (user) {
      let currentRestaurants = localStorage.getItem("current_restaurants_data");
      let currentRestaurant = JSON.parse(currentRestaurants).filter(
        (restInfo) =>
          restInfo.id == this.restNum && restInfo.rest_id == this.restId
      );
      // console.log(currentRestaurants);
      this.currentRestaurantsArr = JSON.parse(currentRestaurants);
      this.userPhone = currentRestaurant[0].rest_phone;
      this.userName = currentRestaurant[0].rest_name;
      this.userAddress = currentRestaurant[0].rest_address;
      this.user.uId = JSON.parse(user).id;
      this.user.userId = JSON.parse(user).user_id;
      this.user.uName = JSON.parse(user).name;
      this.user.uEmail = JSON.parse(user).email;
      this.user.uPassword = JSON.parse(user).password;
      this.user.uMemberSince = JSON.parse(user).member_since;
      this.user.uAddress = JSON.parse(user).full_address;
      this.user.uPhone = JSON.parse(user).phone_number;
      this.user.uRole = JSON.parse(user).role;
      this.getUserName(this.userAccessCode);
      //if role isnt manager or admin, redirect
      if (
        JSON.parse(user).role !== "mngr" &&
        JSON.parse(user).role !== "admn"
      ) {
        this.$router.push({ name: "Login" });
      }
    } else {
      this.$router.push({ name: "Login" });
    }
  },
  computed: {
    ...mapState([
      "__RestaurantId",
      "__RestaurantEmail",
      "__RestaurantRole",
      "__RestaurantName",
      "__MainUrl",
    ]),
    ...mapGetters(["MainUrl"]),
  },
  methods: {
    ...mapMutations(["setRestaurantInfo"]),
    async getUserName(userId) {
      let fd = new FormData();
      fd.append("userId", userId);
      let rst = await axios.post(this.apiMainUrl + `?action=getUserName`, fd);
      if (rst.status == 200) {
        const resultData = rst.data;
        if (!resultData.error) {
          this.userNameIs = this.capitalizeFisrtLetterOfEachWord(
            resultData.name
          );
        }
      }
    },
    capitalizeFisrtLetterOfEachWord(text) {
      return text
        .toLowerCase()
        .split(" ")
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
    },
    //validate Restaurant Name
    validateRestaurantPhone(e) {
      let val = e.target.value;
      this.validateRestaurantPhoneInput(val);
    },
    validateRestaurantPhoneInput(val) {
      // let userPhoneRegex = /^\d{10}$/;
      console.log("User Id: " + val);
      if (val == "") {
        this.userPhoneErr = true;
        this.isuserPhoneValidated = false;
        this.userPhoneMsg = "Enter employee access code ..";
      } else {
        this.userPhoneErr = false;
        this.isuserPhoneValidated = true;
        this.userPhoneMsg = "";
      }
    },
    async RemoveUserFromMyRestaurant() {
      this.resultErr = false;
      this.resultErrMsg = "";
      this.resultSuccess = true;
      this.resultSuccessMsg =
        "Please wait while we're removing current user access from selected restaurant...";
      this.validateRestaurantPhoneInput(this.userAccessCode);
      if (this.isuserPhoneValidated) {
        this.signUpBtn = false;
        //show Result
        let fd = new FormData();
        fd.append("userId", this.user.userId);
        fd.append("restId", this.restId);
        fd.append("accessCode", this.userAccessCode);
        let rst = await axios.post(
          this.apiMainUrl + `?action=RemoveUserFromMyRestaurant`,
          fd
        );
        console.log(rst);
        const resultData = rst.data;
        if (rst.status == 200) {
          if (resultData.error) {
            console.warn("Error Removing User from your restaurant");
            this.resultErrMsg = resultData.message;
            this.resultErr = true;
            this.resultSuccessMsg = "";
            this.resultSuccess = false;
            this.signUpBtn = true;
          } else {
            this.signUpBtn = false;
            console.log("Good Job, user has been removed..");
            //if everything is okay
            this.resultErrMsg = "";
            this.resultErr = false;
            this.resultSuccess = true;
            //redirect only if customer
            this.resultSuccessMsg = resultData.message;
            setTimeout(() => {
              this.$router.push({
                name: "AccessUsersToOnlineOrders",
                params: {
                  restId: this.restId,
                  id: this.restNum,
                },
              });
            }, 2000);
          }
        }
      } else {
        this.signUpBtn = true;
        this.validateRestaurantPhoneInput(this.userAccessCode);
        this.resultSuccessMsg = "";
        this.resultSuccess = false;

        this.resultErrMsg = "Must enter all required information";
        this.resultErr = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$navColor: #3f51b6;

nav a {
  text-decoration: none;
  color: $navColor;
  font-weight: bold;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #ffffff;
}
</style>
